function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rating-15_svg__a",
  d: "M.001 0H80v79.999H.001z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rating-15_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rating-15_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M40 78.597C18.685 78.597 1.404 61.317 1.404 40 1.404 18.684 18.685 1.404 40 1.404c21.315 0 38.597 17.28 38.597 38.596 0 21.317-17.282 38.597-38.597 38.597M40 0C17.91 0 .001 17.909.001 40c0 22.092 17.908 39.999 40 39.999 22.091 0 40-17.907 40-40C80 17.91 62.091 0 40 0",
  fill: "#000",
  mask: "url(#rating-15_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 75.088c-19.378 0-35.087-15.708-35.087-35.087C4.913 20.623 20.623 4.913 40 4.913c19.38 0 35.088 15.71 35.088 35.088C75.088 59.38 59.38 75.088 40 75.088m0-73.684C18.685 1.403 1.404 18.683 1.404 40S18.685 78.596 40 78.596c21.315 0 38.597-17.28 38.597-38.596C78.597 18.685 61.315 1.404 40 1.404",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 4.912C20.622 4.912 4.913 20.622 4.913 40c0 19.38 15.71 35.088 35.087 35.088 19.38 0 35.088-15.709 35.088-35.088C75.088 20.622 59.38 4.912 40 4.912",
  fill: "#FB4F93"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.18 25.52v28.078h-5.115V37.542c0-2.663 0-3.452-2.29-3.452h-4.574v-3.203h.54c2.622-.042 6.157-.083 7.28-5.366h4.159zm21.789 4.618H43.03l-.957 6.197c1.247-1.247 3.244-2.08 5.407-2.08 4.991 0 8.527 3.702 8.527 9.36 0 5.782-3.785 10.357-10.44 10.357-1.872 0-3.703-.332-5.326-1.164-3.91-2.08-4.2-5.7-4.325-7.071l5.824-.417c.124 2.87 1.913 4.16 4.035 4.16.957 0 1.788-.208 2.453-.666 1.248-.832 2.122-2.786 2.122-4.991 0-3.495-2.163-5.283-4.658-5.283-1.914 0-3.536.874-4.202 2.62l-4.701-.29 1.996-15.433h15.6l-.416 4.7z",
  fill: "#FFF"
}));

function SvgRating15(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2);
}

export default SvgRating15;